import {
	DONE,
	IN_PROGRESS,
	TODO,
	UNDEFINED,
	statusCategoryForId,
} from '@atlassian/jira-common-constants/src/status-categories.tsx';
import {
	DARK_GREEN,
	DARK_BLUE,
	DARK_GREY,
	type Color,
} from '@atlassian/jira-issue-epic-color/src/common/types.tsx';

const colorMap = {
	[UNDEFINED]: DARK_GREY,
	[TODO]: DARK_GREY,
	[DONE]: DARK_GREEN,
	[IN_PROGRESS]: DARK_BLUE,
} as const;

export const getColor = (categoryId?: string): Color => colorMap[statusCategoryForId(categoryId)];
